import en from './en'
import es from './es'

const languages = { en, es }

export default languages
